import { Box } from '@mui/material'
import { IProjectDTO } from 'data/dtos/automation/i-project-dto'
import React, { Fragment } from 'react'
import { useHistory } from 'react-router-dom'
import BadgeConnector from 'utils/project/connector-badge'
import { useStyles } from './styles'

interface ProjectListCard {
  project: IProjectDTO
}

const ContractToolsCard: React.FC<ProjectListCard> = ({ project }) => {
  const classes = useStyles()
  const history = useHistory()

  const handleNavigate = () => history.push(`/projects/${project.id}`)

  const apps = project?.recipes?.filter((recipe) => recipe.type == 'app')

  return (
    <Box
      className={classes.root}
      onClick={handleNavigate}
    >
      <div className={classes.header}>
        <h2>{project?.name}</h2>
      </div>

      <div className={classes.footer}>
        <div className={classes.item}>
          <p>Conectores</p>

          <div className={classes.connectorsBox}>
            {project?.connectors.map((connector, index) => (
              <BadgeConnector
                key={index}
                name={connector.name}
                index={index}
              />
            ))}
          </div>
        </div>

        <div className={classes.item}>
          {apps?.length > 0 && (
            <Fragment>
              <p>Apps</p>

              <div className={classes.connectorsBox}>
                {apps?.map((connector, index) => (
                  <BadgeConnector
                    key={index}
                    name={connector.appName}
                    index={index}
                  />
                ))}
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </Box>
  )
}

export default ContractToolsCard
